import { useFormikContext } from "formik";
import React from "react";

import { EntryColor, EntryFile, EntryText } from "../../../components/Entry";
import EventForm from "../../../components/EventForm";
import useFile from "../../../hooks/useFile";

const Design = () => {
  const { onUpload } = useFile();
  const { setFieldValue } = useFormikContext();
  // ...
  const onUploadFile = async (key, files) => {
    const data = await onUpload(files);
    setFieldValue([key], data[0]);
  };
  // ...
  return (
    <div className="BadgeStep __design">
      <h3 className="BadgeStep__title">Badge builder</h3>
      <div className="BadgeStep__groups">
        <div className="__group">
          <EventForm>
            <EntryColor
              label="Text color"
              name="textColor"
              placeholder="white"
              xs={6}
              md={4}
            />
            <EntryColor
              label="Background color"
              name="backgroundColor"
              placeholder="white"
              xs={6}
              md={4}
            />
            <EntryFile
              compact
              label="Background image"
              name="backgroundImage"
              placeholder="Local image"
              onUpload={onUploadFile}
              xs={12}
              md={4}
            />
          </EventForm>
        </div>
        <div className="__group __typo">
          <div className="__title">Badge main infos:</div>
          <div className="__subgroups">
            <div
              className="__subgroups__group __left"
              style={{ marginTop: "30px" }}
            >
              <EventForm>
                <EntryText
                  name="text"
                  label="Text"
                  placeholder="Full name"
                  xs={12}
                  md={12}
                />
                <EntryText
                  name="subText1"
                  label="Sub heading 1"
                  placeholder="Organization"
                  xs={12}
                  md={12}
                />
                <EntryText
                  name="subText2"
                  label="Sub heading 2"
                  placeholder="location"
                  xs={12}
                  md={12}
                />
                <EntryText
                  name="subText3"
                  label="Sub heading 3"
                  placeholder="Category"
                  xs={12}
                  md={12}
                />
              </EventForm>
            </div>
            <div className="__subgroups__group __right __qr">
              <div className="__qr-bar">
                <img src="/static/icons/badge_layout.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Design;
